/**
 * @typedef {Object} ExpenseCategoryResponseDto
 * @property {number} categoryId
 * @property {string} categoryName
 * @property {boolean} isActive
 * @property {string} createdDate
 * @property {string} createdBy
 * @property {string} [modifiedDate]
 * @property {string} [modifiedBy]
 */

/**
 * @typedef {Object} ExpenseResponseDto
 * @property {number} expenseId
 * @property {number} categoryId
 * @property {string} categoryName
 * @property {number} amount
 * @property {string} expenseDate
 * @property {string} [periodFrom]
 * @property {string} [periodTo]
 * @property {string} [notes]
 * @property {boolean} isActive
 * @property {string} createdDate
 * @property {string} createdBy
 * @property {string} [modifiedDate]
 * @property {string} [modifiedBy]
 */

/**
 * @typedef {Object} ExpenseCategorySummaryDto
 * @property {number} categoryId
 * @property {string} categoryName
 * @property {number} totalAmount
 */

const BASE = '/v1/expense';

export default (instance) => ({
  getCategories: (params = {}) =>
    instance.get(`${BASE}/categories`, { params }),

  createCategory: (payload) =>
    instance.post(`${BASE}/categories`, payload),

  updateCategory: (categoryId, payload) =>
    instance.put(`${BASE}/categories/${categoryId}`, payload),

  deleteCategory: (categoryId) =>
    instance.delete(`${BASE}/categories/${categoryId}`),

  getAll: (params = {}) =>
    instance.get(BASE, { params }),

  getSummary: (params = {}) =>
    instance.get(`${BASE}/summary`, { params }),

  create: (payload) =>
    instance.post(BASE, payload),

  update: (expenseId, payload) =>
    instance.put(`${BASE}/${expenseId}`, payload),

  delete: (expenseId) =>
    instance.delete(`${BASE}/${expenseId}`)
});
